import { Markdown } from '../../components/Markdown';
import { PageHeader } from '../../components/PageHeader';
import { useDict } from '../../i18n/dictionary';
import { useLocale } from '../../lib/locale';
import { usePageTitle } from '../../lib/page';
import type { Story } from '../../lib/story';
import { libraryDict } from './i18n';

/** A story's description, then every variant rendered live under its name. */
export function StoryPage({ story }: { story: Story }) {
  const t = useDict(libraryDict);
  const { locale } = useLocale();
  const title = story.title[locale];
  usePageTitle(t.storyTitle(title));

  return (
    <>
      <PageHeader title={title} />
      <div className="form-hint">
        <Markdown>{story.description[locale]}</Markdown>
      </div>
      <div className="library-sections">
        {story.variants.map((variant) => (
          <section key={variant.name.en}>
            <h2 className="heading-section">{variant.name[locale]}</h2>
            <div className="story-canvas">{variant.render(locale)}</div>
          </section>
        ))}
      </div>
    </>
  );
}
